module.exports = __webpack_public_path__ + "static/media/finance.ef0730bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/finance.png
// module id = 230
// module chunks = 0